import { CheckCircleIcon } from '@chakra-ui/icons';
import {
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Button,
  Center,
  useDisclosure,
  ModalCloseButton,
  List,
  ListItem,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../../AccountContext';

export default function AvisoTelefone(props) {
  const disclosure = props.disclosure;
  const { user, setUser } = useContext(AccountContext);
  const navigate = useNavigate();

  const isPhoneMissing = !user.phone1 || user.phone1 === undefined || user.phone1 === null || user.phone1 === '';
  const isBirthMissing = !user.data_aniv || user.data_aniv === undefined || user.data_aniv === null || user.data_aniv === '';
  const isCepMissing = !user.cep || user.cep === undefined || user.cep === null || user.cep === '';
  const onlyCepMissing = isCepMissing && !isPhoneMissing && !isBirthMissing;

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered size="xs">
        <ModalOverlay />
        <ModalContent boxShadow="4px 4px 7px rgba(0, 0, 0, 0.25)" borderRadius="15px">
          <ModalHeader mt="3">
            <VStack spacing={3}>
              <Heading size="md">
                <Center>
                  <Text fontSize="2em" color="#585858">
                    Atenção!
                  </Text>
                </Center>
              </Heading>
            </VStack>
          </ModalHeader>
          <ModalBody mb="3">
            <VStack spacing={3} align="start">
              <Text color="#5AB2AE" fontWeight="bold" fontSize="1em" textAlign="left">
                {onlyCepMissing
                  ? 'Para seguir com o uso do app é necessário atualizar seus dados de endereço.'
                  : <>
                    Para seguir com o uso do app é necessário atualizar
                    {isPhoneMissing && ' seu número de telefone'}
                    {(isPhoneMissing && isBirthMissing) ? ', ' : ''}
                    {isBirthMissing && ' sua data de nascimento'}
                    {isCepMissing && !onlyCepMissing && ' e seus dados de endereço'}
                    .
                  </>
                }
              </Text>
              <Button
                colorScheme="teal"
                isFullWidth
                borderColor="blue.500"
                borderRadius="1.1em"
                fontWeight="bold"
                onClick={() => {
                  disclosure.onClose();
                  if (onlyCepMissing) {
                    navigate('/perfil/endereco');
                  } else {
                    navigate('/perfil/dados-pessoais', {
                      state: { defaultIndex: isPhoneMissing ? 1 : 0 },
                    });
                  }
                }}
              >
                Atualizar agora
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
